import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NetworkCallService } from '../../core/services/network-call.service';
import { HelpersService } from '../../core/services/helpers.service';
import { of } from 'rxjs';
import { switchMap, map, catchError } from 'rxjs/operators';
import { IStaticDataResponse } from '../models/static-data.model';
import { fromAccountTypesAction } from '../actions';

@Injectable()
export class StaticDataAccountTypesEffects {
  constructor(
    private actions$: Actions,
    private networkCallService: NetworkCallService,
    private helpers: HelpersService
  ) {}

  loadAccountTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromAccountTypesAction.loadAccountTypes),
      switchMap(() =>
        this.networkCallService.get<IStaticDataResponse[]>(
          'StaticData/AccountTypes'
        ).pipe(
          map(response => fromAccountTypesAction.loadAccountTypesSuccess({ response })),
          catchError(error => {
            return of(fromAccountTypesAction.loadAccountTypesFailure({ error }));
          })
        )
      )
    )
  );
}